import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule } from 'primeng/primeng';

import { Ng2BRPipesModule } from 'ng2-brpipes';

import { SispacSharedModule } from '../shared/sispac-shared.module';

import { EditalCredenciamentoRouting } from './edital-credenciamento.routing';

import { EditalCredenciamentoService } from './edital-credenciamento.service';

import { EditalCredenciamentoFormComponent } from './edital-credenciamento-form/edital-credenciamento-form.component';
import { GerenciarEditalCredenciamentoComponent } from './gerenciar-edital-credenciamento/gerenciar-edital-credenciamento.component';
import {MultiSelectModule} from 'primeng/multiselect';


@NgModule({
    declarations: [
        EditalCredenciamentoFormComponent,
        GerenciarEditalCredenciamentoComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule, ReactiveFormsModule,

        EditalCredenciamentoRouting,

        ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule,

        Ng2BRPipesModule,

        SispacSharedModule,
        MultiSelectModule
    ],
    providers: [ EditalCredenciamentoService ],
  
})
export class EditalCredenciamentoModule { }



// WEBPACK FOOTER //
// ./src/app/components/editalCredenciamento/edital-credenciamento.module.ts